// Static
import menuList from '@/app/static/json/breeder-nav-menu-links.json';

// Mixins
import { comingSoonMixins } from '@/app/mixins/utils/coming-soon-mixins';

export default {
	name: 'BreederSidebar',
	components: {},
    mixins: [
	    comingSoonMixins,
	],
	data() {
		return {
			menuList: menuList,
			displaySideBar: false,
			fadeSideBar: false,
			activeLinkId: "puppy-sales",
		}
	},
	computed: {
		showSideBar() {
			this.animateSideBar();
			return this.$store.getters.getSideBar;
		},
	},
	watch: {
		'$route': {
			immediate: true,
			handler(url) {
				if(!url && !url.path){
					return;
				}

				const firstPath = url.path.split("/").filter(d => d !== "").at(0);
				// const lastPath = url.path.split("/").at(-1);
				
				this.activeLinkId = firstPath;

			}
		}
	},
	async created() {
	},
	methods: {
		animateSideBar() {
			const sidebar = this.$store.getters.getSideBar;
			let timeout = sidebar ? 50 : 250;
			
			if (sidebar) {
				this.displaySideBar = sidebar;
				setTimeout(() => {
					this.fadeSideBar = sidebar;
				}, timeout);
			} else {
				this.fadeSideBar = sidebar;
				setTimeout(() => {
					this.displaySideBar = sidebar;
				}, timeout);
			}
		},
		getIcon(icon) {
			// src/assets/images/breeder-sidebar/puppy-sales.png
			return require(`@/assets/images/breeder-sidebar/${icon}`);
		},
		toggleSideBar() {
			this.$store.commit('toggleSideBar');
			this.animateSideBar();
		},
		closeSideBarOnNavigate() {
			this.$store.commit('closeSideBar');
			this.animateSideBar();
		},
		async navigateToPath(url, isComingSoon = false) {
			if(isComingSoon){
				this.showHomeComingSoonAlert();
				return;
			}
			
			if (this.$route.path !== url) {
				this.$router.push(url,  () => {});
			}

			this.closeSideBarOnNavigate();
		},
	}
};
